import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAnalytics: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"analytics, analysis"} maskId="square-filled-radius-0-stroke-1-IconAnalytics"><path d="M3 11.5V3H21V11.5H17.2771L14.5136 7.07828L9.48581 14.6199L7.25731 11.5H3Z" fill="currentColor"/><path d="M3 12.5V21H21V12.5H16.7229L14.4864 8.92172L9.51419 16.3801L6.74269 12.5H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAnalytics;
